<template>
  <v-dialog
    :value="value"
    @input="(v) => $emit('input', value)"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card color="neutral700">
      <SizeBox height="8" />
      <div class="d-flex justify-end">
        <v-avatar
          size="24"
          @click="$emit('input', false)"
          class="cursor-pointer"
        >
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
        <SizeBox width="8" />
      </div>
      <v-card-title class="flex-center pt-1">
        {{ $t('AUTH.WORD.RESET_PASSWORD') }}
      </v-card-title>
      <v-card-text class="text-center text-pre-wrap">
        <v-form ref="RESET_FORM">
          <v-text-field
            :label="$t('AUTH.COPYWRITING.PLEASE_ENTER_A_NEW_PASSWORD')"
            name="newPassword"
            background-color="neutral800"
            v-model="newPassword"
            :rules="[$rules.required]"
            :type="peekNewPassword ? 'text' : 'password'"
            :append-icon="peekNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="peekNewPassword = !peekNewPassword"
            @keyup.enter="submit"
            outlined
            dense
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="flex-center">
        <v-btn outlined width="120" @click="$emit('input', false)">
          {{ $t('COMMON.WORD.CANCEL') }}
        </v-btn>
        <SizeBox width="16" />
        <v-btn
          width="120"
          depressed
          color="primary"
          @click="submit"
          :loading="isLoading"
        >
          {{ $t('COMMON.WORD.CONFIRM') }}
        </v-btn>
      </v-card-actions>
      <SizeBox height="18" />
    </v-card>
  </v-dialog>
</template>

<script>
import { resetPassword } from '@/api/auth';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      peekNewPassword: false,
      newPassword: ''
    };
  },

  methods: {
    async submit() {
      if (!this.$refs.RESET_FORM.validate()) return;
      this.isLoading = true;
      const query = this.$router.resolve(location.href).route.query;
      const { username, code } = query;
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';

      const { error } = await resetPassword({
        username,
        code,
        password: this.newPassword,
        lang: lang
      });

      if (!error) {
        this.$toast(this.$t('AUTH.WORD.PASSWORD_CHANGED'));
        this.$emit('input', false);
      } else {
        !!error.message && this.$toast.error(error.message);
      }

      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>